var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_vm._t("header"),_vm._t("body"),_vm._t("footer"),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("X")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }